/**
 * Created by mnaughton on 12/4/2015.
 */

export default {
  Button: "button",
  Check: "check",
  CheckBox: "checkbox",
  Color: "color",
  Custom: "custom",
  Date: "date",
  Email: "email",
  File: "file",
  Formatted: "formatted",
  FromNow: "fromnow",
  Image: "image",
  Link: "link",
  Number: "number",
  Phone: "phone",
  Radio: "radio",
  Select: "select",
  Text: "text",
  TextArea: "textarea",
  Url: "url",
};



//////////////////
// WEBPACK FOOTER
// ./public/js/core/models/FieldTypes.js
// module id = 124
// module chunks = 1